import { useSyncExternalStore } from 'react';

const MOBILE_BREAKPOINT = 639; // matches Tailwind's sm breakpoint
const query = `(max-width: ${MOBILE_BREAKPOINT}px)`;
const mq = typeof window !== 'undefined' ? window.matchMedia(query) : null;

function subscribe(callback: () => void) {
  mq!.addEventListener('change', callback);
  return () => mq!.removeEventListener('change', callback);
}

function getSnapshot() {
  return mq!.matches;
}

function getServerSnapshot() {
  return false;
}

/** Shared mobile detection — single matchMedia listener across all callers. */
export function useIsMobile() {
  return useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
}

const DESKTOP_BREAKPOINT = 1024; // matches Tailwind's lg breakpoint
const desktopQuery = `(min-width: ${DESKTOP_BREAKPOINT}px)`;
const desktopMq = typeof window !== 'undefined' ? window.matchMedia(desktopQuery) : null;

function desktopSubscribe(callback: () => void) {
  desktopMq!.addEventListener('change', callback);
  return () => desktopMq!.removeEventListener('change', callback);
}

function getDesktopSnapshot() {
  return desktopMq!.matches;
}

function getDesktopServerSnapshot() {
  return false;
}

/** Shared desktop detection — single matchMedia listener across all callers. */
export function useIsDesktop() {
  return useSyncExternalStore(desktopSubscribe, getDesktopSnapshot, getDesktopServerSnapshot);
}
